export default __webpack_public_path__ + "locales/vi/Article.json?hash=2cbfff0c7aa78af3a9e5431654de5a6b";